import React from "react";
import { createRoot } from "react-dom";
import UserConfirmationPopup from "src/Components/UserConfirmationPopup";
import __ from "src/utils/Translations";

const isOptionsObject = (value) =>
  value !== null && typeof value === "object" && !React.isValidElement(value);

const toOptions = (optionsOrPositionalArgs) => {
  const [first] = optionsOrPositionalArgs;
  if (isOptionsObject(first)) return first;

  const [
    noCbOnClose,
    additionalButtons,
    confirmLabel,
    cancelLabel,
    buttonStyle,
  ] = optionsOrPositionalArgs;
  return {
    noCbOnClose,
    additionalButtons,
    confirmLabel,
    cancelLabel,
    buttonStyle,
  };
};

/**
 * Opens a confirmation popup and reports the user's choice via `callback`.
 * `message` and `title` are displayed as given, so pass them translated with
 * __(). `confirmLabel` / `cancelLabel` are translated by UserConfirmationPopup
 * itself – pass the Polish phrase; when omitted, its "Tak" / "Nie" are used.
 */
function getUserConfirmationPopup(
  message,
  callback,
  title = `${__("Czy na pewno chcesz opuścić tę stronę")}?`,
  ...optionsOrPositionalArgs
) {
  const {
    noCbOnClose,
    additionalButtons,
    confirmLabel,
    cancelLabel,
    buttonStyle,
  } = toOptions(optionsOrPositionalArgs);

  if (!message) {
    callback(true);
    return;
  }
  const container = document.createElement("div");
  container.setAttribute("custom-confirmation-navigation", "");
  document.body.appendChild(container);
  const root = createRoot(container);
  const onUserRespondHandler = (callbackState, noCallback) => {
    root.unmount();
    if (!noCallback) callback(callbackState);
  };
  root.render(
    <UserConfirmationPopup
      title={title}
      onClose={() => onUserRespondHandler(false, noCbOnClose)}
      onCancel={() => onUserRespondHandler(false)}
      onConfirm={() => onUserRespondHandler(true)}
      message={message}
      additionalButtons={additionalButtons}
      confirmLabel={confirmLabel}
      cancelLabel={cancelLabel}
      buttonStyle={buttonStyle}
    />
  );
}

export default getUserConfirmationPopup;
